import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { translate } from '../../../Services/translation';
import { handleTermsAndConditionsAccepted } from '../../../Actions/Login.action';
import EditorString from '../../EditorString';
import Input from './../../Input';
import { useIsBendixTheme, useIsApexTheme } from '../../../Hooks/ChannelHooks';

const TermsAndConditions = (props) => {
  const dispatch = useDispatch();
  const { terms } = props;
  const [acceptMarketing, setAcceptMarketing] = useState(false);
  const [acceptTerms, setAcceptTerms] = useState(false);
  const isBendix = useIsBendixTheme();
  const isApex = useIsApexTheme();

  const tncAccepted = (fields) => {
    dispatch(handleTermsAndConditionsAccepted(fields));
  };

  // Apex: the terms modal captures terms acceptance only (marketing consent is captured
  // on the set-password screen). Other brands keep the existing behaviour.
  if (isApex) {
    return (
      <div className="terms">
        <div
          className="terms__content terms__content--scroll"
          style={{
            maxHeight: '240px',
            overflowY: 'auto',
            border: '1px solid #d6d6d8',
            borderRadius: '4px',
            padding: '12px 16px',
            marginBottom: '16px',
          }}
        >
          <EditorString value={terms} />
        </div>
        <div className="input-field-wrapper">
          <Input
            id="acceptTerms"
            type="checkbox"
            wrapperClassName="terms__input-checkbox-wrapper"
            className="terms__input-checkbox"
            checked={acceptTerms}
            onChange={() => setAcceptTerms(!acceptTerms)}
            label={translate('general.accept-terms-checkbox')}
          />
        </div>
        <button
          className="login__submit-button login__submit-button-terms"
          disabled={!acceptTerms}
          onClick={() => tncAccepted({})}
        >
          {translate('general.accept-terms')}
        </button>
      </div>
    );
  }

  return (
    <div className="terms">
      <EditorString value={terms} />
      {!isBendix && (
        <div className="input-field-wrapper">
          <Input
            id="acceptMarketing"
            type="checkbox"
            wrapperClassName="terms__input-checkbox-wrapper"
            className="terms__input-checkbox"
            checked={acceptMarketing}
            onChange={() => setAcceptMarketing(!acceptMarketing)}
            label={translate('general.accept-marketing-terms')}
          />
        </div>
      )}
      <button
        className="login__submit-button login__submit-button-terms"
        onClick={() =>
          tncAccepted({
            acceptMarketing,
          })
        }
      >
        {translate('general.accept-terms')}
      </button>
    </div>
  );
};

export default TermsAndConditions;
